import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { RemoveModal } from 'shared/components/RemoveModal';
import { deleteWorkflow } from 'services/workflow/actionCreators';
import { getIsDeletingWorkflowFlag } from 'services/workflow/getters';

import { RemoveWorkflowModalProps } from './types';

const REMOVE_WORKFLOW_MODAL = 'remove-workflow-modal';
const REMOVE_WORKFLOW_MODAL_OVERLAY_CLASS_NAME = 'remove-workflow-modal__overlay';

const StyledConfirmationMessage = styled.p`
  max-width: 39.67rem;
  word-wrap: break-word;
  font-size: 1.167rem;
`;

const StyledRemoveModal = styled(RemoveModal).attrs({
  overlayClassName: REMOVE_WORKFLOW_MODAL_OVERLAY_CLASS_NAME,
})`
  .${REMOVE_WORKFLOW_MODAL_OVERLAY_CLASS_NAME} {
  }
`;

const RemoveWorkflowModal = ({
  workflow,
  onClose,
}: RemoveWorkflowModalProps) => {
  const dispatch = useDispatch();
  const isDeletingSafelist = useSelector(getIsDeletingWorkflowFlag);

  const onSubmit = useCallback(() => {
    dispatch(deleteWorkflow(workflow));
  }, [workflow.guid]);

  return (
    <StyledRemoveModal
      name={REMOVE_WORKFLOW_MODAL}
      title='Remove Workflow'
      onSubmit={onSubmit}
      isSubmitting={isDeletingSafelist}
      submitButtonLabel='Remove Workflow'
      overlayClassName={REMOVE_WORKFLOW_MODAL_OVERLAY_CLASS_NAME}
      onClose={onClose}
    >
      <StyledConfirmationMessage>
        Are you sure you want to remove this workflow?
      </StyledConfirmationMessage>
    </StyledRemoveModal>
  );
};

export {
  RemoveWorkflowModal,
  REMOVE_WORKFLOW_MODAL,
};
